import { Box, Button, Grid } from "@mui/material"

import { safeFormatDate } from "../../../utils/utilityFunctions"
import { DlspTable } from "./DlspTable"
import { useState } from "react"
import DlspLandOwnerPermissionForm from "./DlspLandOwnerPermissionForm"
import { DlspPermissionIcon } from "../../styled/DlspPermissionIcon";




// const fakeLandOwnerPermission = {
//     permissionReceived: 'Yes',
//     permissionFromName: 'Mickly Buckley',
//     permissionFromPhone: '022 4340288',
//     permissionFromEmail: 'micklybuckley@gmail.com',
//     permissionDate: '2023-12-01T00:05:00+12:00',
// }

export function DlspLandOwnerPermissionPanel({taskDetails, onEdited, fspStatusNoEdit}) {
    const [isEditing, setIsEditing] = useState(false)

    console.log('DlspLandOwnerPermissionPanel', {taskDetails})

    const handleEditLandOwnerPermissionClose = () => {
        setIsEditing(false)
        onEdited()
    }
    return (
        <Box>
        {
            isEditing
            ?
            <DlspLandOwnerPermissionForm
                landOwners={taskDetails?.landowners}
                landOwnerPermission={taskDetails?.decomICP?.landownerPermission}
                icpNumber={taskDetails?.decomICP?.icp}
                address={taskDetails?.decomICP?.address}
                onClose={handleEditLandOwnerPermissionClose}
                />
            :
            <>
                <LandOwnerPermissionDetails
                    landOwnerPermission={taskDetails?.decomICP?.landownerPermission}
                    inspectedBy={taskDetails?.decomICP?.desktopInspBy}
                    inspectionDate={taskDetails?.decomICP?.desktopInspDate}
                />
                <Button variant="contained" disabled={fspStatusNoEdit} sx={{my:1}} color="primary" onClick={() => setIsEditing(true)}>Edit Land Owner Permission</Button>
            </>
        }
        </Box>
    )
}

function LandOwnerPermissionDetails({landOwnerPermission}) {

    const landOwnerLabel = <><DlspPermissionIcon className={landOwnerPermission?.permissionReceived} /><br /><span>Permission Received</span></>
    const leftTableRows = []
    leftTableRows.push({label: 'Land Owner Contacts',    text: landOwnerPermission?.landOwnerContacts })
    leftTableRows.push({label: 'Land Owner Comments',    text: landOwnerPermission?.landOwnerComments })
    leftTableRows.push({label: landOwnerLabel,    text: landOwnerPermission?.permissionReceived || 'No' })
    if (landOwnerPermission?.permissionReceived === 'Yes') {
        const permissionDetails = [
            landOwnerPermission?.permissionFromName,
            landOwnerPermission?.permissionFromPhone,
            landOwnerPermission?.permissionFromEmail,
            safeFormatDate(landOwnerPermission?.permissionDate),
        ]
        leftTableRows.push({label: 'Permission From',   text: <span>{permissionDetails.map((p, i) => <span key={i}>{p}<br/></span>)}</span> }) 
    }
    

    const rightTableRows = []

    return (
        <Box sx={{my: 2}}>
        {
            (!landOwnerPermission)
            ?
            <></>
            :
            <Grid container spacing={2}>
                <Grid item md={6}>
                    <DlspTable rows={leftTableRows} skipHeader={true} leftColSx={{width: '30%'}} />
                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={rightTableRows} skipHeader={true} />
                </Grid>
            </Grid>
        }
        </Box>
    )
}